export const LOGIN_CALLBACK_ROUTE = "/auth0/login-callback";
export const LOGOUT_CALLBACK_ROUTE = "/auth0/logout-callback";
